import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import DefaultProductImg from "../../../../assets/img/default_product.jpeg";
import DefaultSubProductImg from "../../../../assets/img/default_sub_product.jpeg";
import {isProductSoldOut, TranslatedAttribute} from "../../../../utils";
import {productResourcePrice} from "../../../../helpers/price_handler";

const LABEL_STYLES = {
  new: 'bg-green-100 text-green-800',
  star: 'bg-amber-100 text-amber-800',
  chefs_suggestion: 'bg-purple-100 text-purple-800',
};

const Product = ({item, sub_product = false}) => {
  const {currencySymbol} = useSelector(state => state.app);
  const {locale} = useSelector(state => state.app);
  const {soldOutProductIds} = useSelector(state => state.app);
  const {t} = useTranslation();
  const soldOut = isProductSoldOut(item, soldOutProductIds);
  const render_product = () => {
    return (
      <div className={'flex w-full' + (soldOut ? ' opacity-50' : '')}>
        <img className={'rounded-[12px] my-[10px] ml-[10px] w-[90px] h-auto object-cover'}
             src={item.image_url || DefaultProductImg} alt={''}/>
        <div className={'ml-2 flex flex-col my-[5px]'}>
          <p className={'title text-[15pt] font-medium whitespace-pre line-clamp-1 text-wrap'}>
            {TranslatedAttribute(locale, item, 'name')}
          </p>
          <p className={'desc text-[10pt] mb-auto line-clamp-2 text-wrap'}>{item.description}</p>
          <div className={'flex flex-row items-center justify-between mt-auto'}>
            <div className={'desc text-[12pt]'}>
              {
                  item.sub_items && item.sub_items.length > 0 ? (
                  <></>
                ) : (
                  <>
                    <p className={'text-[15pt] font-medium inline'}>
                      {parseFloat(productResourcePrice(item)).toFixed(2)}
                    </p>
                    <p className={'inline ml-1'}>
                      {currencySymbol}
                    </p>
                  </>
                )
              }
            </div>
            <div className={'flex flex-row flex-wrap gap-1 justify-end'}>
              {soldOut && (
                <span className={'text-[10px] font-semibold px-2 py-0.5 rounded-full bg-red-100 text-red-800'}>
                  {t('general.sold_out')}
                </span>
              )}
              {item.labels && item.labels.length > 0 && (
                item.labels.map((label) => (
                  <span key={label} className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${LABEL_STYLES[label] || 'bg-gray-100 text-gray-700'}`}>
                    {t(`labels.${label}`)}
                  </span>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
  const render_sub_product = () => {
    return (
      <div className={'flex w-full' + (soldOut ? ' opacity-50' : '')}>
        <img className={'rounded-[12px] my-[10px] ml-[10px] w-[55px] h-auto object-cover'}
             src={item.image_url || DefaultSubProductImg} alt={''}/>
        <div className={'ml-2 flex flex-col my-[5px]'}>
          <p className={'title text-[13pt] font-medium whitespace-pre line-clamp-1 text-wrap'}>
            {TranslatedAttribute(locale, item, 'name')}
          </p>
          <p className={'desc text-[8pt] mb-auto line-clamp-1 text-wrap'}>{item.description}</p>
        </div>
        <div className={'ml-auto mr-1 flex flex-col items-end justify-center'}>
          <p className={'desc text-[10pt]'}>
            {
                item.sub_items && item.sub_items.length > 0 ? (
                <></>
              ) : (
                <>
                  <p className={'text-[13pt] font-medium inline'}>
                    {parseFloat(productResourcePrice(item)).toFixed(2)}
                  </p>
                  <p className={'inline ml-1'}>
                    {currencySymbol}
                  </p>
                </>
              )
            }
          </p>
          {(soldOut || (item.labels && item.labels.length > 0)) && (
            <div className={'flex flex-row flex-wrap gap-1 justify-end mt-1'}>
              {soldOut && (
                <span className={'text-[9px] font-semibold px-2 py-0.5 rounded-full bg-red-100 text-red-800'}>
                  {t('general.sold_out')}
                </span>
              )}
              {item.labels && item.labels.length > 0 && (
                item.labels.map((label) => (
                  <span key={label} className={`text-[9px] font-semibold px-2 py-0.5 rounded-full ${LABEL_STYLES[label] || 'bg-gray-100 text-gray-700'}`}>
                    {t(`labels.${label}`)}
                  </span>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
  return (
    <>
      {
        sub_product ? (
          render_sub_product()
        ) : (
          render_product()
        )
      }
    </>
  )
}

export default Product
